// Backend/client origins are configurable through env for easy switching (defaults to local)
export const config = {
    backendPath: process.env.REACT_APP_BACKEND_URL || 'http://localhost:1052',
    clientPath: process.env.REACT_APP_CLIENT_URL || 'http://localhost:1051',
    adminPath: process.env.REACT_APP_ADMIN_URL || 'http://localhost:1062',
};
